import Vue from 'vue'
import Vuex from 'vuex'
import Setting from './Setting/index'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Setting
  },
  state: {
    storeStatus: localStorage.getItem('storeStatus') || null,
    storeActive: localStorage.getItem('storeActive') || null
  },
  mutations: {
    changeStoreStatus (state, payload) {
      state.storeStatus = payload
      localStorage.setItem('storeStatus', payload)
    },
    changeStoreActive (state, payload) {
      state.storeActive = payload
      localStorage.setItem('storeActive', payload)
    }
  },
  actions: {
  },
  getters: {
    getStoreStatus: state => state.storeStatus,
    getStoreActive: state => state.storeActive
  },
  strict: debug
})
